export const INFO_LETTERS = 'INFO_LETTERS';
export const SYSTEM_NOTIFICATIONS = 'SYSTEM_NOTIFICATIONS';

export const INFO_LETTERS_FROM_EMAIL = 'marketing';
export const SYSTEM_NOTIFICATIONS_FROM_EMAIL = 'system';
